import {MatchmakingCancelReason} from '../../../../../../../../shared/matchmaking/MatchmakingEnums.ts'
import {SocketMatchmakingSend} from '../../../../../../../shared/scripts/socket/SocketMatchmakingSend.ts'
import {type UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView.ts'
import {UIMMatchmakingSearching1v1View} from './UIMMatchmakingSearching1v1View.ts'
import {UIMMatchmakingSearchingClassic4PView} from './UIMMatchmakingSearchingClassic4PView.ts'
import {UIMMatchmakingSearchingCnKView} from './UIMMatchmakingSearchingCnKView.ts'
import {type MatchmakingStatusUpdate} from '../../../../../../../../shared/matchmaking/MatchmakingInterfaces.ts'
import {UIMMatchmakingActionsController} from '../UIMMatchmakingActionsController.ts'
import {type BotsMatchType, isBotMatchType, MatchmakingMatchTypes, type MatchType} from '@colonist/game-base-types'
import {getMatchTypeEligibilityAndCreatePopup, isShuffleBotGame, startBotGame, startShuffleBotGame} from '../../../../../../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts'
import {ClientUserState} from '../../../../../../../shared/scripts/ClientUserState.ts'
import {UIMMatchmakingSearchingShuffleView} from './UIMMatchmakingSearchingShuffleView.ts'
import {UIMMatchmakingSearchingRush4PView} from './UIMMatchmakingSearchingRush4PView.ts'

export class UIMMatchmakingController {
    private matchmakingSearchingView?: UIMMatchmakingSearchingView
    readonly matchmakingActionsController: UIMMatchmakingActionsController

    constructor() {
        this.matchmakingActionsController = new UIMMatchmakingActionsController()
    }

    async startGame(matchType: MatchType) {
        if(isBotMatchType(matchType)) {
            startBotGame(matchType as BotsMatchType)
            return
        }

        const matchmakingType = matchType as MatchmakingMatchTypes

        const {isEligible, createPopup} = getMatchTypeEligibilityAndCreatePopup(matchmakingType)
        createPopup?.()
        if(!isEligible) return

        await ClientUserState.requireUser()

        if(isShuffleBotGame(matchmakingType)) {
            startShuffleBotGame()
            return
        }

        switch(matchmakingType) {
            case MatchmakingMatchTypes.UnrankedClassic1v1:
            case MatchmakingMatchTypes.RankedClassic1v1:
                this.matchmakingSearchingView = new UIMMatchmakingSearching1v1View(this, matchmakingType)
                break
            case MatchmakingMatchTypes.UnrankedClassic4P:
            case MatchmakingMatchTypes.RankedClassic4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingClassic4PView(this, matchmakingType)
                break
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingCnKView(this)
                break
            case MatchmakingMatchTypes.RankedRush4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingRush4PView(this)
                break
            case MatchmakingMatchTypes.UnrankedShuffle:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingShuffleView(this)
                break
            default:
                return
        }

        this.matchmakingActionsController.sendFindGameMessageToServer(matchmakingType)
    }

    stopSearching() {
        this.matchmakingSearchingView?.removeFromDOM()
        SocketMatchmakingSend.sendCancelFindGame(MatchmakingCancelReason.ClickedCancel)
    }

    removeSearchingScreen() {
        this.matchmakingSearchingView?.removeFromDOM()
    }

    updateMatchmakingStatus(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        this.matchmakingSearchingView?.updateStatus(matchmakingStatusUpdate)
    }
}
